import { render, staticRenderFns } from "./SalaryConfigHistory.vue?vue&type=template&id=00e1fc9e&scoped=true"
import script from "./SalaryConfigHistory.vue?vue&type=script&lang=js"
export * from "./SalaryConfigHistory.vue?vue&type=script&lang=js"
import style0 from "./SalaryConfigHistory.vue?vue&type=style&index=0&id=00e1fc9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e1fc9e",
  null
  
)

export default component.exports